import { Trans, useTranslation } from 'react-i18next';

import { Text } from '@actual-app/components/text';
import { View } from '@actual-app/components/view';

import { SelectorTrato } from '#components/mobile/travesia/SelectorTrato';
import { useTrato } from '#components/mobile/travesia/trato';
import { color, texto } from '#components/mobile/ui/tokens';

/**
 * Ajustes → «Cómo te hablo»: la forma con la que Gavi habla a la persona en
 * este dispositivo (pref global `tratoPerfil`), la misma del paso 0 de la
 * travesía. Se guarda al tocar; tocar la marcada la quita.
 */
export function TratoSettings() {
  const { t } = useTranslation();
  const { trato, setTrato } = useTrato();
  return (
    <View style={{ gap: 12 }} data-testid="trato-ajustes">
      <Text style={{ ...texto.secundario, color: color.fg2 }}>
        <Trans>
          So Gavi gets the words right. Tap the chosen option again to leave it
          unset.
        </Trans>
      </Text>
      <SelectorTrato
        etiqueta={t('How I talk to you')}
        testId="ajuste-trato"
        valor={trato}
        onChange={setTrato}
      />
    </View>
  );
}
